/**
 * DevMode — bypass admin pra testar fases trancadas sem grindar estrelas.
 *
 * Quando ativo, `isWorldUnlocked` e `isLevelUnlocked` retornam true pra
 * qualquer mundo/fase. Estado persiste em localStorage com chave própria
 * (não mexe no SaveData) pra não vazar pra um save sincronizado online
 * no futuro.
 *
 * NÃO usar em produção pra "premium unlock" — a senha é hardcoded e
 * roda no cliente. É puramente uma ferramenta interna de desenvolvimento.
 */

const STORAGE_KEY = 'tabuadageek:dev-mode';
const ADMIN_PASSWORD = '0509';

let cached: boolean | null = null;

/** Tenta ler do localStorage; primeira chamada hidrata o cache em memória. */
export function isDevModeEnabled(): boolean {
  if (cached !== null) return cached;
  try {
    cached = typeof localStorage !== 'undefined' && localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    // SSR/ambientes sem storage: assume desligado.
    cached = false;
  }
  return cached;
}

export function setDevModeEnabled(value: boolean): void {
  cached = value;
  try {
    if (value) localStorage.setItem(STORAGE_KEY, '1');
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Ignora — o estado em memória já reflete a mudança.
  }
}

/** Retorna true se a senha bate com a admin (ativando o modo como efeito colateral). */
export function tryUnlockWithPassword(password: string): boolean {
  if (password.trim() === ADMIN_PASSWORD) {
    setDevModeEnabled(true);
    return true;
  }
  return false;
}
